import { BaseExpressionElement, DocumentReference, SwimlaneGroup } from '@InstanceFactory';

export class SwimlaneGroupOperand implements BaseExpressionElement {
    $type?: string;

    constructor(public swimlaneGroup: DocumentReference<SwimlaneGroup>) {}

    representation: string;
}
